import type { Handler } from './handler';
import type { ApiPostDailyCheckinClaimPort } from './ports/api-post-daily-checkin-claim.port';
import type { DailyCheckinClaimResult } from '~/types/daily-checkin';
import { resolveAdapter } from '~/adapters/registry';

// POST /daily-check-in/claim. Não recebe qual degrau resgatar: quem decide é o
// servidor.
export const postDailyCheckinClaimHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiPostDailyCheckinClaim: resolveAdapter('apiPostDailyCheckinClaim'),
  },
) => {
  return await ports.apiPostDailyCheckinClaim.handle({ userId: params.userId });
};

type Params = { userId: number };

type Ports = { apiPostDailyCheckinClaim: ApiPostDailyCheckinClaimPort };

type Result = Promise<DailyCheckinClaimResult>;
